import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-137d5130"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, null, -1))
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = { class: "seeMore" }
const _hoisted_6 = {
  key: 3,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, null, -1))
const _hoisted_8 = { class: "section-title" }
const _hoisted_9 = { class: "seeMore" }
const _hoisted_10 = {
  key: 5,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider" }, null, -1))
const _hoisted_12 = {
  key: 7,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_13 = { class: "ion-text-center ion-margin-top" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["href"]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_img = _resolveComponent("logo-img")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_cart_button = _resolveComponent("cart-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_slides = _resolveComponent("slides")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_product_card = _resolveComponent("product-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createVNode(_component_logo_img)
                ]),
                _: 1
              }),
              (!$setup.loading)
                ? (_openBlock(), _createBlock(_component_ion_buttons, {
                    key: 0,
                    slot: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openBrowser($setup.companyInfo.websiteUrl)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.compass
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_cart_button)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              ($setup.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_ion_spinner)
                  ]))
                : (_openBlock(), _createBlock(_component_slides, {
                    key: 1,
                    banners: $setup.banners.map(b => b.imageLink)
                  }, null, 8, ["banners"])),
              (!$setup.loading)
                ? (_openBlock(), _createBlock(_component_ion_toolbar, {
                    key: 2,
                    mode: "md"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment, {
                        onIonChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.categorySegmentChanged($event))),
                        scrollable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allProductCategories, (category) => {
                            return (_openBlock(), _createBlock(_component_ion_segment_button, {
                              class: "product-category-btn",
                              mode: "md",
                              key: category.id,
                              value: category.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_avatar, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: category.imageLink
                                    }, null, 8, _hoisted_2)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(category.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_3,
              _createElementVNode("h2", _hoisted_4, [
                _createVNode(_component_ion_icon, { icon: $setup.bag }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString($setup.t('HomePage.featuredProducts')), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_ion_button, {
                  fill: "clear",
                  size: "small",
                  "router-link": "/products"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.t('HomePage.seeMore')), 1)
                  ]),
                  _: 1
                })
              ]),
              ($setup.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_ion_spinner)
                  ]))
                : (_openBlock(), _createBlock(_component_slides, {
                    key: 4,
                    products: $setup.featuredProducts
                  }, null, 8, ["products"])),
              _hoisted_7,
              _createElementVNode("h2", _hoisted_8, [
                _createVNode(_component_ion_icon, { icon: $setup.alertCircle }, null, 8, ["icon"]),
                _createTextVNode(_toDisplayString($setup.t('HomePage.latestProducts')), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ion_button, {
                  fill: "clear",
                  size: "small",
                  "router-link": "/products"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.t('HomePage.seeMore')), 1)
                  ]),
                  _: 1
                })
              ]),
              ($setup.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_ion_spinner)
                  ]))
                : (_openBlock(), _createBlock(_component_ion_row, { key: 6 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.latestProducts, (product) => {
                        return (_openBlock(), _createBlock(_component_ion_col, {
                          "size-xs": "6",
                          "size-md": "4",
                          "size-xl": "3",
                          key: product.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_product_card, {
                              product: product,
                              hideDetails: "true"
                            }, null, 8, ["product"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })),
              _hoisted_11,
              ($setup.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_ion_spinner)
                  ]))
                : (_openBlock(), _createBlock(_component_ion_card, {
                    key: 8,
                    class: "card"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ion_icon, {
                          class: "icon-xl",
                          icon: $setup.informationCircle,
                          color: "warning"
                        }, null, 8, ["icon"])
                      ]),
                      ($setup.companyInfo.introductionEn || $setup.companyInfo.introduction)
                        ? (_openBlock(), _createBlock(_component_ion_card_header, {
                            key: 0,
                            class: "ion-text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h1", null, _toDisplayString($setup.t('HomePage.aboutUs')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "ion-text-center",
                            style: {"white-space":"pre-line","font-size":"15px"},
                            innerHTML: $setup.locale == 'zh' ? $setup.companyInfo.introduction : ($setup.companyInfo.introductionEn || $setup.companyInfo.introduction)
                          }, null, 8, _hoisted_14)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h1", null, _toDisplayString($setup.t('HomePage.contactUs')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card_content, { class: "ion-text-center contact-info" }, {
                        default: _withCtx(() => [
                          ($setup.companyInfo.companyEmail)
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_15, [
                                _createVNode(_component_ion_icon, {
                                  class: "icon-md",
                                  icon: $setup.mail
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString($setup.t('HomePage.companyEmail')), 1),
                                _createElementVNode("a", {
                                  href: `mailto:${$setup.companyInfo.companyEmail}`
                                }, _toDisplayString($setup.companyInfo.companyEmail), 9, _hoisted_16)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.companyInfo.companyPhone)
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_17, [
                                _createVNode(_component_ion_icon, {
                                  class: "icon-md",
                                  icon: $setup.call
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString($setup.t('HomePage.companyPhone')), 1),
                                _createElementVNode("a", {
                                  href: `tel:${$setup.companyInfo.companyPhone}`
                                }, _toDisplayString($setup.companyInfo.companyPhone), 9, _hoisted_18)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.companyInfo.companyAddressEn || $setup.companyInfo.companyAddress)
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_19, [
                                _createVNode(_component_ion_icon, {
                                  class: "icon-md",
                                  icon: $setup.location
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString($setup.t('HomePage.companyAddress')) + _toDisplayString($setup.locale == 'zh' ? $setup.companyInfo.companyAddress : ($setup.companyInfo.companyAddressEn || $setup.companyInfo.companyAddress)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      ($setup.companyInfo.mapIframeSrc)
                        ? (_openBlock(), _createElementBlock("iframe", {
                            key: 1,
                            src: $setup.companyInfo.mapIframeSrc,
                            width: "100%",
                            style: {"border":"0"},
                            allowfullscreen: "",
                            loading: "lazy"
                          }, null, 8, _hoisted_20))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}